export default {"src":"/_next/static/media/store-l.c2c65d40.svg","height":24,"width":24};